module.exports = __webpack_public_path__ + "static/img/lcu.3114612.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/content/lcu.svg
// module id = efap
// module chunks = 1